/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const listSubscriptionsQueryParamsSchema = z.object({
    "pageSize": z.optional(z.any().describe("Items per page (default 25, max 100)")),
"page": z.optional(z.any().describe("Page number (default 1)")),
"enabled": z.optional(z.any().describe("Filter by enabled state")),
"userId": z.optional(z.any().describe("Only this owner’s subscriptions"))
    }).optional()

/**
 * @description Event subscriptions page
 */
export const listSubscriptions200Schema = z.object({
    "items": z.array(z.object({
    "id": z.string(),
"userId": z.string(),
"userName": z.nullable(z.string()),
"name": z.string(),
"targetUrl": z.string(),
"headerNames": z.array(z.string()),
"eventTypes": z.array(z.enum(["contact.event.detected", "contact.summary.completed"])),
"enabled": z.boolean(),
"lastSuccessAt": z.nullable(z.iso.datetime()),
"lastFailureAt": z.nullable(z.iso.datetime()),
"lastErrorMessage": z.nullable(z.string()),
"consecutiveFailureCount": z.int().min(-9007199254740991).max(9007199254740991),
"autoDisabledAt": z.nullable(z.iso.datetime()),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })),
"total": z.int().min(-9007199254740991).max(9007199254740991),
"page": z.int().min(-9007199254740991).max(9007199254740991),
"pageSize": z.int().min(-9007199254740991).max(9007199254740991)
    })

/**
 * @description Invalid query params
 */
export const listSubscriptions400Schema = z.any()

/**
 * @description Caller is not an admin
 */
export const listSubscriptions403Schema = z.any()

export const listSubscriptionsQueryResponseSchema = z.lazy(() => listSubscriptions200Schema)